<template>
  <v-select
    :disabled="disabled"
    :items="periods"
    v-model="period"
    prepend-inner-icon="access_time"
    append-icon="keyboard_arrow_down" 
    persistent-hint
    item-text="displayName"
    return-object
    :hint="$t('selecciona.periodo')"
  ></v-select>
</template>

<script>
export default {
  props: ['disabled'],

  data() {
    return {
      /* Podemos verlo en 3 períodos */
      periodModes: {
        ANUAL: 'Anual',
        TRIMESTRAL: 'Trimestral',
        MENSUAL: 'Mensual'
      },
    }
  },

  computed: {
    periods() {
      const indicadores = this.$store.getters.indicadores
      return Object.keys(this.periodModes)
        .filter(
          p => !!(indicadores[this.indicador] || []).find(i => i.name.indexOf(p.toLowerCase()) > -1 ) )
        .map(str => 
          str.charAt(0).toUpperCase() + str.slice(1).toLowerCase())
        .map(key => ({
          key,
          displayName: this.$t(`periodos.${key.toLowerCase()}`)
        }))
    },

    indicador() {
      return this.$store.getters.indicador
    },

    period: {
      get() {
        const key =  this.$store.getters.period
        return {
          key,
          displayName: this.$t(`periodos.${key.toLowerCase()}`)
        }
      },
      set({key}){ this.$store.dispatch('setPeriod', key) }
    }
  }
}
</script>



// WEBPACK FOOTER //
// select-period.vue?2861bb88